export default {
    RandomColor() {
        const getRandomInt = (min, max) =>
            Math.floor(Math.random() * (max - min)) + min;

        const r = getRandomInt(0, 255);
        const g = getRandomInt(0, 255);
        const b = getRandomInt(0, 255);

        return `rgb(${r},${g},${b})`;
    },

    changeColor(input) {
        const presets = ['primary', 'success', 'danger', 'warning', 'dark'];

        if (presets.includes(input)) {
            const style = getComputedStyle(document.documentElement);

            return this.getVariable(style, `--vs-${input}`);
        }

        if (/^(rgb|rgba)\(/.test(input)) {
            // "rgb(12,34,56)" -> "12,34,56"
            return input.replace(/^(rgb|rgba)\(|\)$/g, '').replace(/\s/g, '');
        }

        if (/^#/.test(input)) {
            const rgb = this.hexToRgb(input);

            return `${rgb.r},${rgb.g},${rgb.b}`;
        }

        return `--vs-${input}`;
    },

    contrastColor(value) {
        let c = value;

        if (/^#/.test(value)) {
            const rgb = this.hexToRgb(value);
            c = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
        }

        const parts = c
            .replace(/^(rgb|rgba)\(/, '')
            .replace(/\)$/, '')
            .replace(/\s/g, '')
            .split(',');

        const r = Number(parts[0]);
        const g = Number(parts[1]);
        const b = Number(parts[2]);

        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

        return yiq >= 128;
    },

    darken(color, percent) {
    // принимает "rgb(r,g,b)" или "rgba(r,g,b,a)"
        const nums = color
            .replace(/^(rgb|rgba)\(/, '')
            .replace(/\)$/, '')
            .replace(/\s/g, '')
            .split(',')
            .map(Number);

        const [r, g, b] = nums;
        const t = percent < 0 ? 0 : 255;
        const p = percent < 0 ? -percent : percent;

        const rr = Math.round((t - r) * p) + r;
        const gg = Math.round((t - g) * p) + g;
        const bb = Math.round((t - b) * p) + b;

        return `rgb(${rr},${gg},${bb})`;
    },

    getColor(color, alpha = 1, keepDefaultAlpha = true) {
    // hex -> rgb/rgba
        if (/^#/.test(color)) {
            const c = this.hexToRgb(color);

            return alpha === 1
                ? `rgb(${c.r},${c.g},${c.b})`
                : `rgba(${c.r},${c.g},${c.b},${alpha})`;
        }

        // rgba -> при необходимости заменить альфу
        if (/^rgba\(/.test(color)) {
            const hasDigitParenAtEnd = /\d\)$/.test(color);

            if (!hasDigitParenAtEnd && !keepDefaultAlpha) {
                return color.replace(/[^,]+(?=\)$)/, String(alpha));
            }

            return color;
        }

        // rgb -> при необходимости превратить в rgba
        if (/^rgb\(/.test(color) && alpha !== 1) {
            const body = color.replace(/^rgb\(/, '').replace(/\)$/, '');

            return `rgba(${body},${alpha})`;
        }

        return color;
    },

    getVariable(styles, propertyName) {
        return String(styles.getPropertyValue(propertyName)).trim();
    },

    hexToRgb(hex) {
    // расширяем короткий вид #abc -> #aabbcc
        const shorthand = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        const full = hex.replace(
            shorthand,
            (m, r, g, b) => `${r}${r}${g}${g}${b}${b}`,
        );

        const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(full);

        return match
            ? {
                    b: parseInt(match[3], 16),
                    g: parseInt(match[2], 16),
                    r: parseInt(match[1], 16),
                }
            : { b: 0, g: 0, r: 0 };
    },

    isColor(value) {
        const vscolors = [
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'dark',
            'light',
        ];

        return vscolors.includes(value);
    },

    rColor(value, opacity = 1) {
    // #hex
        if (/^#/.test(value)) {
            const c = this.hexToRgb(value);

            return `rgba(${c.r},${c.g},${c.b},${opacity})`;
        }

        // rgba(...)
        if (/^rgba\(/.test(value)) {
            return value;
        }

        // rgb(...) -> rgba(...)
        if (/^rgb\(/.test(value)) {
            const body = value.replace(/^rgb\(/, '').replace(/\)$/, '');

            return `rgba(${body},${opacity})`;
        }

        // именованные пресеты
        const vscolors = ['primary', 'success', 'danger', 'warning', 'dark'];

        if (vscolors.includes(value)) {
            return `rgba(var(--vs-${value}),${opacity})`;
        }

        // дефолт
        return `rgba(var(--vs-primary),${opacity})`;
    },

    setCssVariable(propertyName, value) {
        if (typeof window !== 'undefined') {
            document.documentElement.style.setProperty(propertyName, value);
        }
    },
};
